import { render, staticRenderFns } from "./Position.vue?vue&type=template&id=f5875bcc&scoped=true&"
import script from "./Position.vue?vue&type=script&lang=ts&"
export * from "./Position.vue?vue&type=script&lang=ts&"
import style0 from "./Position.vue?vue&type=style&index=0&id=f5875bcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5875bcc",
  null
  
)

export default component.exports